import React from 'react'
import Helmet from 'react-helmet'
// import CookieConsent from 'react-cookie-consent'
import './css/bootstrap/bootstrap.min.css'
import './css/font.css'
import './css/style.scss'

const TemplateWrapper = ({ children }) => (
  <div className="h-100">
    <Helmet>
      {/* <!-- Meta Tags --> */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="language" content="English" />
      <meta http-equiv="content-language" content="en" />

      <meta name="title" content="Create and run automated mobile test in less than 30 minutes! | Pirlo" />
      <meta name="copyright" content="Pirlo - 2019" />
      <meta name="author" content="Pirlo - https://pirlo.com/" />
      <meta name="description" content="Pirlo can help. Create and run automated mobile test in less than 30 minutes!" />

      {/* <!-- Meta Keywords --> */}
      <meta name="keywords" content="Pirlo, GSuit" />

      {/* <!-- Facebook Meta --> */}
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content="Create and run automated mobile test in less than 30 minutes! | Pirlo" />
      <meta property="og:image" content="https://www.pirlo.app/img/logo-beta.png" />
      <meta property="og:description" content="Pirlo can help. Create and run automated mobile test in less than 30 minutes!" />
      <meta property="og:url" content="https://pirlo.com/" />
      <meta property="og:type" content="business.business" />
      <meta property="og:site_name" content="Pirlo" />
      <meta property="article:publisher" content="https://www.facebook.com/logicwindhq" />

      {/* <!-- Twitter Meta --> */}
      <meta name="twitter:card" content="business.business" />
      <meta name="twitter:title" content="Create and run automated mobile test in less than 30 minutes! | Pirlo" />
      <meta name="twitter:image" content="https://www.pirlo.app/img/logo-beta.png" />
      <meta property="twitter:description" content="Pirlo can help. Create and run automated mobile test in less than 30 minutes!" />

      <title>Create and run automated mobile test in less than 30 minutes! | Pirlo</title>

      {/* <!-- Favicon --> */}
      <link href="/img/fav.ico" rel="icon" type="image/png" />

      {/* Webmaster tool verification code */}
      <meta name="msvalidate.01" content="C662420E78E47B3EB725F62E8ECBD90E" />

    </Helmet>
    <div>
      {children}
    </div>
    {/* <CookieConsent
      location="bottom"
      cookieName="pirlo-cookie"
      style={{ background: "#2B373B", paddingLeft: "50px" }}
      buttonStyle={{ background: "#4285f4", color: "#fff", fontSize: "13px", fontWeight: "500", fontFamily: "Montserrat", marginRight: "100px" }}
      expires={150}
    >
      This website uses cookies to enhance the user experience.
    </CookieConsent> */}
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css" integrity="sha384-B4dIYHKNBt8Bc12p+WXckhzcICo0wtJAoU8YZTY5qE0Id1GSseTk6S+L3BlXeVIU" crossOrigin="anonymous"></link>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.4.1/css/swiper.css" />
    <script src="/js/jquery-2.2.4.min.js"></script>
    <script src="/js/bootstrap/bootstrap.min.js"></script>
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/fancyapps/fancybox@3.5.6/dist/jquery.fancybox.min.css" />
    <script src="https://cdn.jsdelivr.net/gh/fancyapps/fancybox@3.5.6/dist/jquery.fancybox.min.js"></script>
    {/* <script src="https://unpkg.com/react-id-swiper@1.6.8/lib/react-id-swiper.js"></script> */}
  </div>
)

export default TemplateWrapper
